import Grid from '@mui/material/Grid';
import { Paragraph } from 'src/interviews/components/Layout/Embedded';
import Tooltip from './Tooltip';
import { formatSentenceCase } from 'src/interviews/utils/formatTitleCasing';

import type { IInterviewResults } from 'src/packages/polaris/types';

export enum Belief {
  Likely = 'likely',
  Possible = 'possible',
  Unlikely = 'unlikely',
}

const BELIEF_MESSAGE = {
  [Belief.Likely]: (conditionName: string) => ({
    color: '#719B9D',
    level: `${formatSentenceCase(conditionName)} likely`,
    match: (
      <span>
        Your responses strongly relate to symptoms commonly seen in{' '}
        <span className="bp-font-bold">{conditionName}</span>.
      </span>
    ),
  }),
  [Belief.Possible]: (conditionName: string) => ({
    color: '#F9AE0F',
    level: `${formatSentenceCase(conditionName)} possible`,
    match: (
      <span>
        Some of your responses relate to symptoms commonly seen in{' '}
        <span className="bp-font-bold">{conditionName}</span>.
      </span>
    ),
  }),
  [Belief.Unlikely]: (conditionName: string) => ({
    color: '#DD9581',
    level: `${formatSentenceCase(conditionName)} unlikely`,
    match: (
      <span>
        Your responses have limited or no relation to symptoms commonly seen in{' '}
        <span className="bp-font-bold">{conditionName}</span>.
      </span>
    ),
  }),
};

function BeliefComponent({
  conditionName,
  result,
}: {
  conditionName: string;
  result: IInterviewResults;
}) {
  const diagnosis = result.diagnosis_of_concern || ({} as any);

  const belief = Object.values(Belief).includes(diagnosis.belief)
    ? BELIEF_MESSAGE[diagnosis.belief as Belief](conditionName)
    : BELIEF_MESSAGE[Belief.Unlikely](conditionName);

  return (
    <>
      <Grid item>
        <Paragraph className="bp-flex bp-items-center bp-justify-between">
          <div className="bp-mr-2 bp-mt-[-4px] bp-flex bp-gap-2">
            <figure
              className="bp-mt-1 bp-h-4 bp-w-4 bp-shrink-0 bp-rounded-lg"
              style={{ backgroundColor: belief.color }}
            />
            <span className="bp-font-bold">{belief.level}</span>
          </div>
          <Tooltip />
        </Paragraph>
      </Grid>

      <Grid item>
        <Paragraph>{belief.match}</Paragraph>
      </Grid>
    </>
  );
}

export default BeliefComponent;
